export const getUserFirstName = (name: string | null | undefined): string | null => {
    const [firstName] = (name ?? "").trim().split(/\s+/);

    return firstName ? firstName : null;
};
export const getUserFirstName = (name: string | null | undefined): string | null => {
    const [firstName] = (name ?? "").trim().split(/\s+/);

    return firstName ? firstName : null;
};
